import React, { Component } from "react";
import PropTypes from "prop-types";
import DestopIcon from "material-ui/svg-icons/hardware/desktop-mac";
import MobileIcon from "material-ui/svg-icons/communication/stay-primary-portrait";
import Dropzone from "react-dropzone";
import { shallowEqual } from "recompose";
import FlatButton from "material-ui/FlatButton";
import { pinkA200, red500 } from "material-ui/styles/colors";
import CircularProgress from "material-ui/CircularProgress";
import Snackbar from "material-ui/Snackbar";
import RemoveCircle from "material-ui/svg-icons/content/remove-circle";
import { UploadClient } from "../../../restClient";
import { DivContainer, SpanImage, Image, InsideBox, GridImage } from "./styled";
import {
  URL_UPLOAD,
  ERROR_MESSAGE_FAILED,
  ERROR_MESSAGE_MAX_SIZE
} from "./constants";

class UploadImageArray extends Component {
  constructor(props) {
    super(props);
    let photos = props.imageUrl || [];

    let isShowing = true;
    if (photos.length === 1 && photos[0] instanceof Object) {
      isShowing = false;
    }
    this.state = {
      photos: photos,
      isShow: isShowing,
      isLoading: false,
      openSnackBar: false,
      message: "Please try again"
    };
  }
  componentWillReceiveProps(nextProps) {
    let photos = nextProps.imageUrl || [];
    this.setState({ photos: photos });
  }
  onAdd(url) {
    const updatedFiles = [...this.state.photos, url];
    // //console.log(updatedFiles);
    this.setState({ photos: updatedFiles, isLoading: false });
    //console.log(this.state.photos);
    this.props.onUpdateUrl(updatedFiles);
  }
  onRemove = file => () => {
    const filteredFiles = this.state.photos.filter(
      stateFile => !shallowEqual(stateFile, file)
    );
    this.setState({ photos: filteredFiles });
    this.props.onUpdateUrl(filteredFiles);
  };

  onDrop = (accepted, rejected) => {
    const paramsCaption = "image-carousel-" + this.props.type;

    if (accepted.length > 0 && rejected.length === 0) {
      this.setState({
        isLoading: true
      });
      let formData = new FormData();
      formData.append("caption", paramsCaption);
      accepted.forEach(file => {
        formData.append("photos", file, file.name);
      });

      UploadClient(formData, URL_UPLOAD)
        .then(response => response.json())
        .then(data => {
          if (data.url) {
            this.onAdd(data.url);
          } else {
            this.setState({
              isLoading: false,
              openSnackBar: true,
              message: ERROR_MESSAGE_FAILED
            });
          }
        })
        .catch(e => {
          console.error(e);
          this.setState({
            isLoading: false,
            openSnackBar: true,
            message: ERROR_MESSAGE_FAILED
          });
        });
    } else {
      this.setState({
        openSnackBar: true,
        message: ERROR_MESSAGE_MAX_SIZE
      });
    }
  };

  handleRequestClose = () => {
    this.setState({
      openSnackBar: false
    });
  };

  renderItem() {
    return (
      <GridImage>
        {this.state.photos.map((item, index) => {
          return (
            <div key={index} style={styles.container}>
              <FlatButton
                style={styles.removeButton}
                icon={<RemoveCircle color={pinkA200} />}
                onClick={this.onRemove(item)}
              />
              <Image
                src={item}
                style={styles.image}
                alt="delete"
                title="photos"
              />
            </div>
          );
        })}
      </GridImage>
    );
  }
  render() {
    const { disableClick, maxSize, minSize, multiple, type } = this.props;
    return (
      <div>
        <Dropzone
          onDrop={this.onDrop}
          accept="image/*"
          disableClick={disableClick}
          maxSize={maxSize}
          minSize={minSize}
          multiple={multiple}
          style={styles.boxImage}
        >
          {this.state.isLoading && (
            <InsideBox>
              <CircularProgress />
            </InsideBox>
          )}
          {!this.state.isLoading && (
            <InsideBox>
              {type === "mobile" ? (
                <MobileIcon
                  style={{ width: 50, height: 50 }}
                  color={"#173f4f"}
                />
              ) : (
                <DestopIcon
                  style={{ width: 50, height: 50 }}
                  color={"#173f4f"}
                />
              )}
              {type === "desktop" ? (
                <SpanImage>size : 960x400</SpanImage>
              ) : (
                <SpanImage>size : 600x600</SpanImage>
              )}
              {/* <SpanImage>Drop your {title} file here</SpanImage>
              <SpanImage>or Click here</SpanImage> */}
            </InsideBox>
          )}
        </Dropzone>
        <DivContainer>{this.state.isShow && this.renderItem()}</DivContainer>
        <Snackbar
          open={this.state.openSnackBar}
          message={this.state.message}
          autoHideDuration={4000}
          bodyStyle={{ backgroundColor: red500 }}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    );
  }
}

const styles = {
  container: {
    display: "inline-block",
    position: "relative",
    padding: 5
  },
  removeButton: {
    position: "absolute",
    top: "0.5rem",
    right: "0.5rem",
    minWidth: "2rem",
    opacity: 1
  },
  removeButtonHovered: {
    opacity: 1
  },
  image: {
    maxHeight: "15rem",
    margin: "0.2rem",
    maxWidth: "200px"
  },
  boxImage: {
    width: 130,
    height: 130,
    borderWidth: 2,
    padding: "0 6px 0 6px",
    borderColor: "#666",
    borderStyle: "dashed",
    borderRadius: 5
  }
};

UploadImageArray.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  maxSize: PropTypes.number,
  minSize: PropTypes.number,
  multiple: PropTypes.bool,
  disableClick: PropTypes.bool,
  onUpdateUrl: PropTypes.func,
  imageUrl: PropTypes.array
};

UploadImageArray.defaultProps = {
  type: "default",
  multiple: false,
  maxSize: 1000000,
  title: "Image",
  imageUrl: []
};

export default UploadImageArray;



// WEBPACK FOOTER //
// ./src/editor/components/image/UploadImageArray.js